"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function TheMovingForce() {
  return <section data-section-id="80798" id="your-reliable-partner-for-aviation-logistics" className="dark bg-background text-foreground relative min-h-screen flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591502/img/boeing_747_cargo_nose_ndjili.png" alt="Boeing 747 cargo aircraft at N'djili Airport during twilight" className="w-full h-full object-cover saturate-50 contrast-125 brightness-50" />
        {}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(0,0,0,0.2)_0%,rgba(0,0,0,0.75)_100%)]" />
        {}
        <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent opacity-90" />
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 flex flex-col items-center text-center mt-12">
        <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-[5rem] font-extrabold tracking-tight uppercase text-transparent bg-clip-text bg-gradient-to-b from-primary to-white max-w-6xl leading-[0.9] mb-8 drop-shadow-2xl">
          Your Reliable Partner <br className="hidden sm:block" /> For Aviation Logistics.
        </h1>
        
        <p className="text-lg sm:text-xl text-white/90 max-w-2xl mb-12 font-semibold tracking-wide drop-shadow-md">
          Premium Ground Handling & Logistics services at N’djili International Airport. Delivering safety, speed, and efficiency for global aviation partners.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6">
          <Link to="/ServicesPage">
            <Button size="lg" className="h-14 px-8 text-lg font-bold tracking-wider uppercase bg-primary text-primary-foreground hover:bg-primary/90 rounded-sm shadow-[0_0_20px_rgba(234,179,8,0.3)] transition-all hover:shadow-[0_0_30px_rgba(234,179,8,0.5)] hover:-translate-y-0.5">
              Our Services
              <ArrowRight className="ml-2 size-5" />
            </Button>
          </Link>
          <Link to="/ContactPage">
            <Button variant="outline" size="lg" className="h-14 px-8 text-lg font-bold tracking-wider uppercase border-2 border-white/80 text-white hover:bg-white hover:text-black rounded-sm bg-transparent backdrop-blur-md transition-all hover:-translate-y-0.5">
              Contact Hub
            </Button>
          </Link>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3 z-10 opacity-80 hover:opacity-100 transition-opacity cursor-default">
        <span className="text-[10px] uppercase tracking-[0.4em] text-primary font-black">
          Discover
        </span>
        <div className="w-[2px] h-16 bg-white/10 relative overflow-hidden rounded-full">
          <div className="absolute top-0 left-0 w-full h-1/2 bg-primary animate-scroll-down rounded-full shadow-[0_0_15px_rgba(234,179,8,0.8)]" />
        </div>
      </div>

      {}
      <style>{`
        @keyframes scroll-down {
          0% { transform: translateY(-100%); opacity: 0; }
          20% { opacity: 1; }
          80% { opacity: 1; }
          100% { transform: translateY(200%); opacity: 0; }
        }
        .animate-scroll-down {
          animation: scroll-down 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
        }
      `}</style>
    </section>;
}